import React from "react";
import { ArrowsOut, CircleNotch, Minus, ArrowsInSimple, ArrowsOutSimple } from "@phosphor-icons/react";
import { TYPE_BY_VALUE, daysSince } from "./constants";

const MinimizedTray = React.forwardRef(function MinimizedTray(
  { notes, onRestore, onEdit, types, highlightDrop, onToggleMinimizeAll, isAllMinimized },
  ref
) {
  const isEmpty = !notes || notes.length === 0;

  return (
    <div
      ref={ref}
      className={`sticky top-0 left-0 right-0 z-20 glass border-b transition-all px-4 py-2 ${
        highlightDrop
          ? "border-ink/40 bg-amber-200/70 ring-2 ring-ink/20"
          : "border-white/30"
      } ${isEmpty && !highlightDrop ? "opacity-60 hover:opacity-100" : ""}`}
      data-testid="minimized-tray"
    >
      <div className="flex items-center gap-2 mb-1.5">
        <Minus size={12} weight="bold" className="text-ink/70" />
        <span className="text-[10px] uppercase tracking-[0.18em] font-bold text-ink/70">
          ΕΛΑΧΙΣΤΟΠΟΙΗΜΕΝΑ
        </span>
        <span className="text-[10px] font-bold text-ink/50">
          ({notes ? notes.length : 0})
        </span>
        {highlightDrop && (
          <span className="text-[10px] font-bold text-amber-700 uppercase tracking-wider animate-pulse">
            ΑΦΗΣΕ ΕΔΩ ΓΙΑ ΣΥΡΡΙΚΝΩΣΗ
          </span>
        )}
        {onToggleMinimizeAll && (
          <button
            onClick={onToggleMinimizeAll}
            className={`ml-auto px-2.5 py-1 rounded-full flex items-center gap-1.5 transition-all text-[10px] font-bold uppercase tracking-[0.15em] border active:scale-95 ${
              isAllMinimized
                ? "bg-amber-400 text-ink border-amber-500 hover:bg-amber-500"
                : "bg-white/70 text-ink/80 border-ink/15 hover:border-ink/40 hover:text-ink"
            }`}
            data-testid="toggle-minimize-all-btn"
            title={isAllMinimized ? "ΕΠΑΝΑΦΟΡΑ ΟΛΩΝ" : "ΣΥΡΡΙΚΝΩΣΗ ΟΛΩΝ"}
          >
            {isAllMinimized ? (
              <ArrowsOutSimple size={11} weight="bold" />
            ) : (
              <ArrowsInSimple size={11} weight="bold" />
            )}
            {isAllMinimized ? "ΕΠΑΝΑΦΟΡΑ ΟΛΩΝ" : "ΣΥΡΡΙΚΝΩΣΗ ΟΛΩΝ"}
          </button>
        )}
      </div>
      {isEmpty ? (
        <div className="text-[10px] text-ink/45 italic font-semibold pb-1">
          ΣΥΡΕ ΕΝΑ POST ΕΔΩ ΓΙΑ ΕΛΑΧΙΣΤΟΠΟΙΗΣΗ
        </div>
      ) : (
        <div className="flex flex-wrap gap-2">
          {notes.map((n) => {
            const meta = TYPE_BY_VALUE[n.type] || types[0];
            const days = daysSince(n.created_at);
            return (
              <div
                key={n.id}
                className="flex items-center gap-2 px-2.5 py-1.5 rounded-full text-xs shadow-sm hover:shadow-md transition-shadow cursor-pointer border border-ink/10"
                style={{ backgroundColor: meta.color }}
                data-testid={`minimized-${n.id}`}
                onClick={() => onEdit(n)}
                title={meta.label}
              >
                <span
                  className="w-2 h-2 rounded-full"
                  style={{
                    backgroundColor: meta.color,
                    boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.3)",
                  }}
                />
                <span className="font-arial font-bold text-ink/85 truncate max-w-[140px]">
                  {n?.data?.customer || "ΧΩΡΙΣ ΠΕΛΑΤΗ"}
                </span>
                {n.in_progress && (
                  <span
                    className="text-[9px] font-black text-red-600 flex items-center gap-0.5"
                    data-testid={`minimized-in-progress-${n.id}`}
                    title="ΣΕ ΕΞΕΛΙΞΗ"
                  >
                    <CircleNotch
                      size={10}
                      weight="bold"
                      className="animate-spin"
                      style={{ animationDuration: "2.5s" }}
                    />
                    ΕΞΕΛ.
                  </span>
                )}
                <span className="text-[9px] font-bold text-ink/45 px-1 rounded bg-white/40">
                  {days === 0 ? "NEW" : `${days}d`}
                </span>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onRestore(n);
                  }}
                  className="ml-1 p-0.5 rounded-full hover:bg-black/10"
                  data-testid={`minimized-restore-${n.id}`}
                  title="ΕΠΑΝΑΦΟΡΑ"
                >
                  <ArrowsOut size={12} weight="bold" />
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
});

export default MinimizedTray;
